@if (order) {
  <div class="request-refund-dialog-content" mat-dialog-content>
    <div class="dialog-header">
      <div class="dialog-title-with-progress-cont">
        @if (isDesktop) {
          <app-progress-indicator
            [currentStep]="step"
            [numberOfSteps]="numberOfSteps"
            [isCircle]="true"
          >
          </app-progress-indicator>
        } @else if (!isDesktop) {
          <div class="mobile-back" (click)="previousStep()">
            <i class="far fa-chevron-left icon-regular"></i>
          </div>
        }
        <div class="dialog-title-custom">
          {{ headerTitle | translate }}
          @if (!isDesktop && step > 1) {
            ({{ step }}/{{ numberOfSteps }})
          }
        </div>
      </div>

      <div class="close-button-custom">
        <i class="far fa-times icon-regular" (click)="close()"></i>
      </div>
    </div>

    @if (!isDesktop) {
      <app-progress-indicator
        [currentStep]="step"
        [numberOfSteps]="numberOfSteps"
      >
      </app-progress-indicator>
    }
    <div class="dialog-body">
      @if (step === 1) {
        <div class="request-refund-process">
          <div class="process-title">
            {{ "APP.REQUEST_REFUND.DO_YOU_REALLY_WANT_REFUND" | translate }}
          </div>
          <div class="process-description">
            {{ "APP.REQUEST_REFUND.REFUND_EXPLANATION" | translate }}
          </div>
        </div>
      }
      @if (step !== 1) {
        <div class="refund-wrapper">
          <div class="order-info-wrapper">
            <div class="order-img-cont">
              <img
                [src]="event?.getEncodedMainImage(true)"
                class="key-visual-img"
                alt="Key Visual"
              />
            </div>
            <div class="order-info">
              <div class="order-info-title">
                {{ "APP.REQUEST_REFUND.ORDER" | translate }} #{{
                  order.orderNumber
                }}
              </div>
              @if (order && order.eventSlot) {
                <div class="order-info-description">
                  {{
                    DateUtils.formatEventDateRangeWithWeekday(
                      order.eventSlot.startDate,
                      order.eventSlot.endDate
                    )
                  }}
                </div>
              }
            </div>
          </div>
          <div class="order-total">
            @if (order.eventAttendeeTickets.length > 0) {
              <div class="tickets">
                {{ order.eventAttendeeTickets.length }} x
                {{ order.eventAttendeeTickets[0].eventTicket?.name }} |
                {{ event?.name }}
              </div>
            }

            <div class="total-price">
              @if (event) {
                <div class="sum">
                  {{ order.getDisplayTotalPrice(event.getTicketingCurrency()) }}
                </div>
              }
              <div class="taxes">
                <span>
                  {{ "APP.REQUEST_REFUND.INCLUDE_TAX" | translate }}
                </span>
                <i class="fa-regular fa-circle-info"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        @if (step === 3) {
          <div>
            <div class="confirm-wrapper">
              <i class="far fa-info-circle"></i>
              <div>
                {{
                  "APP.REQUEST_REFUND.REQUEST_REFUND_CONFIRMATION" | translate
                }}
              </div>
            </div>
          </div>
        }
        <div class="refund-wrapper">
          @if (step === 2) {
            <div class="form-title">
              {{ "APP.REQUEST_REFUND.COMPLETE_DATA" | translate }}
            </div>
          }
          <div class="form-title">
            {{ "APP.REQUEST_REFUND.CONTACT_INFORMATION" | translate }}
          </div>
          <div class="icon-info-box">
            <app-icon-info-box
              [title]="order.eventAttendee?.getName() || ''"
              [description]="order.eventAttendee?.getEmail() || ''"
              [icon]="'fa-user'"
            />
          </div>
        </div>
      }
      @if (form && step === 2) {
        <form [formGroup]="form">
          <div class="form-title pb-1">
            {{ "APP.REQUEST_REFUND.REQUEST_INFORMATION" | translate }}
          </div>

          <mat-form-field class="flex-input w-100" appearance="outline">
            <mat-label class="placeholder">
              {{ "APP.REQUEST_REFUND.REFUND_REASON" | translate }}*
            </mat-label>
            <mat-select
              formControlName="refundReason"
              (selectionChange)="changeRefundReason($event)"
            >
              <mat-option
                *ngFor="let reason of RefundReason.getAllRefundReasons()"
                [value]="reason"
              >
                {{ RefundReason.getDisplayName(reason) | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100">
            <textarea
              #message
              cdkTextareaAutosize
              matInput
              formControlName="message"
              maxlength="128"
              placeholder="Message"
              rows="3"
            ></textarea>
            <span matTextSuffix class="charsCount"
              >{{ message.value.length || 0 }} | 128</span
            >
          </mat-form-field>
        </form>
      }
      @if (form && step === 3) {
        <div class="form-title">
          {{ "APP.REQUEST_REFUND.REQUEST_INFORMATION" | translate }}
        </div>
        <div class="icon-info-box">
          <app-icon-info-box
            [title]="'APP.REQUEST_REFUND.REFUND_REASON' | translate"
            [description]="form.controls['refundReason'].value || ''"
            [icon]="'fa-clipboard-list-check'"
          />
        </div>
        <div class="icon-info-box">
          <app-icon-info-box
            [title]="'APP.REQUEST_REFUND.MESSAGE' | translate"
            [description]="form.controls['message'].value || ''"
            [icon]="'fa-message'"
          />
        </div>
      }
    </div>
    <div mat-dialog-actions class="dialog-actions">
      @if (step === 1) {
        <button class="btn btn-primary-text" (click)="close()">
          {{ "APP.GO_BACK" | translate }}
        </button>
        <button class="btn btn-primary" (click)="goNext()">
          {{ "APP.REQUEST_REFUND.PROCEED_WITH_REFUND" | translate }}
        </button>
      } @else if (step === 2) {
        <button class="btn btn-primary" (click)="goNext()">
          {{ "APP.NEXT" | translate }}
        </button>
      } @else {
        <button class="btn btn-primary-text" (click)="goBack()">
          {{ "APP.REQUEST_REFUND.EDIT_DATA" | translate }}
        </button>
        <button class="btn btn-primary" (click)="sendRefundRequest()">
          {{ "APP.REQUEST_REFUND.REQUEST_REFUND" | translate }}
        </button>
      }
    </div>
  </div>
}
